
document.addEventListener('DOMContentLoaded', function () {
  const sectionWrappers = document.querySelectorAll('.animate-on-enter');

  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Animate children only when section is in view
        const fadeElements = entry.target.querySelectorAll('.fade-in-element, .fade-in-item');
        fadeElements.forEach(el => {
          el.classList.add('animate');
        });

        // Stop observing after animation triggered
        sectionObserver.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    threshold: 0.2
  });

  sectionWrappers.forEach(wrapper => {
    sectionObserver.observe(wrapper);
  });
});


/* ==========================================
   SHOPIFY SCROLL ANIMATIONS - JAVASCRIPT
   ========================================== */

// Main animation function
function initSlideAnimations() {
    // Select all elements that need animation
    const slideElements = document.querySelectorAll('.slide-left-heading, .slide-content, .slide-up-image');
    
    // Exit if no elements found
    if (slideElements.length === 0) return;
    
    // Create Intersection Observer
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Add animate-in class when element is visible
                entry.target.classList.add('animate-in');
            }
        });
    }, {
        threshold: 0.1,  // Trigger when 10% of element is visible
        rootMargin: '0px 0px -50px 0px'  // Trigger 50px before element is fully visible
    });

    // Observe all animation elements
    slideElements.forEach(element => {
        observer.observe(element);
    });
}

// Initialize animations when page loads
document.addEventListener('DOMContentLoaded', initSlideAnimations);

// Re-initialize for Shopify dynamic content (sections, cart drawer, etc.)
document.addEventListener('shopify:section:load', initSlideAnimations);

// For older browsers that don't support IntersectionObserver
if (!window.IntersectionObserver) {
    document.addEventListener('DOMContentLoaded', function() {
        const slideElements = document.querySelectorAll('.slide-left-heading, .slide-content, .slide-up-image');
        slideElements.forEach(element => {
            element.classList.add('animate-in');
        });
    });
}

// Optional: Reset animations when sections are unloaded
document.addEventListener('shopify:section:unload', function() {
    const slideElements = document.querySelectorAll('.slide-left-heading, .slide-content, .slide-up-image');
    slideElements.forEach(element => {
        element.classList.remove('animate-in');
    });
});


// -------------product--popup banner js---------------
/* document.addEventListener("DOMContentLoaded", function () {
    const bannerSection = document.querySelector(".banner-section");
    const smartFeatures = document.querySelector(".container--smart-features");

    let hasShownBanner = false;
    let hasScrolled = false;

    // Allow fade-in only after user scrolls
    window.addEventListener("scroll", () => {
      if (window.scrollY < 100) {
        bannerSection.style.opacity = "0";
        bannerSection.style.zIndex = "0";
        hasShownBanner = false;
      } else {
        hasScrolled = true;
      }
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && hasScrolled && !hasShownBanner) {
            bannerSection.style.opacity = "1";
            bannerSection.style.zIndex = "99999";
            hasShownBanner = true;
          }
        });
      },
      { threshold: 0.1 }
    );

    if (smartFeatures) {
      observer.observe(smartFeatures);
    }
  }); */

  // -------------------dropdown-review-sectio----------
const dropdown = document.getElementById('okeReviews-reviews-controls-sort');

if (dropdown) {
   
    dropdown.addEventListener('click', function() {
        this.classList.toggle('open');
    });

   
    document.addEventListener('click', function(event) {
        if (!dropdown.contains(event.target)) {
            dropdown.classList.remove('open');
        }
    });

   
    dropdown.addEventListener('blur', function() {
        setTimeout(() => {
            this.classList.remove('open');
        }, 150);
    });
}

/***********
RECHARGE WIDGET CODE
***********/
function initializeWidget() {
  //initialize frequency select
  let frequencyHTML = "";
  const productJSON = JSON.parse($("#product-json").text());
  const sellingplans = productJSON.selling_plan_groups[0].selling_plans;
  
  /* for (sellingplan in sellingplans) {
    if (sellingplan == 0) {
      if (
        sellingplans[sellingplan]["price_adjustments"][0]["value_type"] ==
        "percentage"
      ) {
        const percentOff =
          sellingplans[sellingplan]["price_adjustments"][0]["value"] / 100;
        let newPrice = productJSON.price - productJSON.price * percentOff;
        newPrice = `$${parseFloat(newPrice / 100).toFixed(2)}`;
        $(".custom-subsave-price").html(newPrice);

         console.log("newPrice. if---->", newPrice);

      } else {
        const amtOff =
          sellingplans[sellingplan]["price_adjustments"][0]["value"];
        let newPrice = productJSON.price - amtOff;
        newPrice = `$${parseFloat(newPrice / 100).toFixed(2)}`;
        $(".custom-subsave-price").html(newPrice);

         console.log("newPrice. eelse---->", newPrice);
      }

     

      $(".custom-otp-price").html(sellingplans[sellingplan].price);
      $('input[name="selling_plan"]').attr(
        "data-value",
        sellingplans[sellingplan].id
      );
      $('input[name="subscription_frequency"]').attr(
        "data-value",
        sellingplans[sellingplan].name
      );
      frequencyHTML += `<div class="custom-frequency-selected"><span class="frequency-name">${sellingplans[sellingplan].name}</span></div><div class="custom-frequency-option-container">`;
    }
    frequencyHTML += `<div class="custom-frequency-option" data-selling-plan="${sellingplans[sellingplan].id}" data-frequency-text="${sellingplans[sellingplan].name}">`;
    frequencyHTML += `<span class="custom-frequency-option-text">${sellingplans[sellingplan].name}</span>`;
    frequencyHTML += "</div>";

    if (sellingplan == sellingplans.length) {
      frequencyHTML += "</div>";
    }
  }

  $(".custom-frequency-select").append(frequencyHTML); */

  $("body").on("click", ".custom-frequency-selected", function (e) {
    let freqSelect = $(this)
      .parent()
      .find(".custom-frequency-option-container");
    if (freqSelect.hasClass("active")) {
      freqSelect.removeClass("active");
    } else {
      freqSelect.addClass("active");
    }
  });

  $("body").on("click", ".custom-frequency-option", function () {
    //console.log($(this));
    $(".custom-frequency-option").removeClass("selected");
    $(".custom-frequency-option-container").removeClass("active");
    $(this).addClass("selected");

    let newText = $(this).attr("data-frequency-text");
    let newId = $(this).attr("data-selling-plan");
    $('input[name="subscription_frequency"]').val(newText);
    $('input[name="selling_plan"]').val(newId);
    $(".custom-frequency-selected span").text(newText);
  });

  $(".custom-otp").on("click", function () {
    $('input[name="selling_plan"]').attr(
      "data-value",
      $('input[name="selling_plan"]').val()
    );
    $('input[name="subscription_frequency"]').attr(
      "data-value",
      $('input[name="subscription_frequency"]').val()
    );

    setTimeout(function () {
      $('input[name="selling_plan"]').val("");
      $('input[name="subscription_frequency"]').val("");
    }, 0);
  });

  $(".custom-subsave").on("click", function () {
    $('input[name="selling_plan"]').val(
      $('input[name="selling_plan"]').attr("data-value")
    );
    $('input[name="subscription_frequency"]').val(
      $('input[name="subscription_frequency"]').attr("data-value")
    );

    setTimeout(function () {
      $('input[name="selling_plan"]').attr(
        "data-value",
        $('input[name="selling_plan"]').val()
      );
      $('input[name="subscription_frequency"]').attr(
        "data-value",
        $('input[name="subscription_frequency"]').val()
      );
    }, 0);
  });
}

function waitForElement(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

waitForElement(".rc_widget").then((el) => {
  $(".custom-widget-container").addClass("active");
  $(".custom-recharge-widget").addClass("active");
  initializeWidget();
});

// var loadWidget = setInterval(isLoaded, 500);

$(".custom-checkbox-container").on("click", function () {
  let checkboxContainer = $(this).parent();
  if (!checkboxContainer.hasClass("active")) {
    $(".custom-option-container").removeClass("active");
    checkboxContainer.addClass("active");
  }
});

const bindDetailsClick = setInterval(() => {
  const $details = $(".details-a");

  if ($details.length > 0) {
    console.log("✅ .details-a found, binding click event");
    
    $details.on("click", function () {
      $(".custom-rc-popup").addClass("active");
      $("body").addClass("custom-rc-popup-active");
    });

    clearInterval(bindDetailsClick); // stop checking once bound
  }
}, 500); // check every 0.5 second

$(".custom-widget-overlay").on("click", function () {
  $(".custom-rc-popup").removeClass("active");
});
$(".custom-rc-popup .icon-close").on("click", function () {
  $(".custom-rc-popup").removeClass("active");
  $("body").removeClass("custom-rc-popup-active");
});

/**********
END WIDGET CODE
**********/

// === Free Shipping Slider Function ===
function freeShippingSlider(cart, country) {
  const items_array = cart.items;
  let is_subscription_product = false;
  let final_line_price = 0;

  if (items_array.length !== 0) {
    for (let i = 0; i < items_array.length; i++) {
      const product_tag_value = items_array[i].properties._is_added_to_cart;
      if (items_array[i].properties.Frequency) {
        is_subscription_product = true;
      }
      if (product_tag_value == "true") {
        final_line_price += items_array[i].final_line_price;
      }
    }

    const free_shipping_price = parseInt($("#cart_progressbox").attr("data-limit"));
    const free_shipping_price_dollars = free_shipping_price / 100;
    const items_subtotal_price = cart.items_subtotal_price - final_line_price;

    if (is_subscription_product) {
      $("#cart-progress").css("width", "100%");
      $("#free_shipping_price_text").text("Hooray! Your order ships free.");
    } else if (items_subtotal_price <= 0) {
      $("#cart-progress").css("width", "0%");
      $("#free_shipping_price_text").text(`$${free_shipping_price_dollars} away from free shipping.`);
    } else if (items_subtotal_price < free_shipping_price) {
      const progress = (items_subtotal_price / free_shipping_price) * 100;
      const away = ((free_shipping_price - items_subtotal_price) / 100).toFixed(2);
      $("#cart-progress").css("width", `${progress}%`);
      $("#free_shipping_price_text").text(`$${away} away from free shipping.`);
    } else {
      $("#cart-progress").css("width", "100%");
      $("#free_shipping_price_text").text("Hooray! Your order ships free.");
    }
  }
}

// === Helper to Update Free Shipping Progress ===
function updateFreeShipping(delay = 300) {
  setTimeout(() => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const country = Shopify.country || "US";
        freeShippingSlider(cart, country);
      })
      .catch(err => console.error('Cart fetch error:', err));
  }, delay);
}

// === 1. Run once on initial page load ===
document.addEventListener('DOMContentLoaded', () => {
  updateFreeShipping(0);
});

// === 2. When cart drawer opens (Horizon’s drawer event or fallback) ===
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-cart-toggle], .header-cart, .open-cart')) {
    // 🛒 Matches Horizon's cart open button
    console.log('🛍️ Cart drawer opened manually');
    updateFreeShipping(200);
  }
});

// === 3. Intercept Shopify fetch calls (add/change/update) ===
(function() {
  const originalFetch = window.fetch;
  let refreshTimeout = null;

  window.fetch = async function(...args) {
    const response = await originalFetch(...args);
    const url = args[0];

    // Detect only cart update actions (avoid loops)
    const cartUpdateEndpoints = [
      '/cart/add.js',
      '/cart/change.js',
      '/cart/update.js',
      'monkcommerce.app',
      'monk-commerce',
    ];

    // Run free shipping update ONLY for add/change/update requests
    if (cartUpdateEndpoints.some(endpoint => url.includes(endpoint))) {
      clearTimeout(refreshTimeout);
      refreshTimeout = setTimeout(() => {
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const country = Shopify.country || "US";
            freeShippingSlider(cart, country);
          })
          .catch(() => {});
      }, 700);
    }

    return response;
  };
})();


document.addEventListener('input', function(e) {
  const el = e.target;
  if (el.name === "properties[Monogram Text]") {
    el.value = el.value.toUpperCase();
  }
});

// ============================================================
// Free Shipping Slider
// ============================================================


function freeShippingSlider(cart) {
  console.log("here in free shipping bar slider");

  let is_subscription_product = false;
  let final_line_price = 0;

  // Calculate subtotal
  cart.items.forEach((item) => {
    if (item.properties?.Frequency) {
      is_subscription_product = true;
    }

    if (item.properties?._is_added_to_cart === "true") {
      final_line_price += item.final_line_price;
    }
  });

  const progressBox = document.querySelector("#cart_progressbox");
  const fill = document.querySelector("#cart-progress");
  const shippingText = document.querySelector(
    "#free_shipping_price_text"
  );
  const shippingMarker = document.querySelector("#shipping-marker");

  const showGift =
    progressBox?.getAttribute("data-show-gift") === "true";

  const giftText = document.querySelector("#free_gift_price_text");
  const giftMarker = document.querySelector("#gift-marker");

  // Gift elements are only required when the setting is enabled
  const giftReady = !showGift || (giftText && giftMarker);

  if (
    !progressBox ||
    !fill ||
    !shippingText ||
    !shippingMarker ||
    !giftReady
  ) {
    console.log("Free shipping elements not available yet");
    return false;
  }

  const freeShippingPrice = parseInt(
    progressBox.getAttribute("data-limit"),
    10
  );

  const freeGiftPrice = showGift
    ? parseInt(progressBox.getAttribute("data-gift-limit"), 10)
    : null;

  if (!freeShippingPrice) {
    return false;
  }

  if (showGift && !freeGiftPrice) {
    return false;
  }

  // Exclude special added-to-cart products
  const itemsSubtotalPrice =
    cart.items_subtotal_price - final_line_price;


  // ============================================================
  // Subscription product
  // ============================================================

  if (is_subscription_product) {
    fill.style.width = "100%";

    shippingText.textContent =
      "Hooray! Your order ships free.";

    shippingText.classList.add("is-complete");
    shippingMarker.classList.add("reached");

    if (showGift) {
      giftText.textContent =
        "You've unlocked a free gift.";

      giftText.classList.add("is-complete");
      giftMarker.classList.add("reached");
    }

    return true;
  }


  // ============================================================
  // Calculate maximum threshold
  // ============================================================

  const maxThreshold = showGift
    ? Math.max(freeShippingPrice, freeGiftPrice)
    : freeShippingPrice;


  // ============================================================
  // Marker positions
  // ============================================================

  shippingMarker.style.left =
    `${(freeShippingPrice / maxThreshold) * 100}%`;

  if (showGift) {
    giftMarker.style.left =
      `${(freeGiftPrice / maxThreshold) * 100}%`;
  }


  // ============================================================
  // Progress bar
  // ============================================================

  const fillPct = Math.min(
    100,
    (itemsSubtotalPrice / maxThreshold) * 100
  );

  fill.style.width = `${fillPct}%`;


  // ============================================================
  // Free Gift
  // ============================================================

  if (showGift) {
    if (itemsSubtotalPrice >= freeGiftPrice) {
      giftText.textContent =
        "You've unlocked a free gift.";

      giftText.classList.add("is-complete");
      giftMarker.classList.add("reached");
    } else {
      const away =
        ((freeGiftPrice - itemsSubtotalPrice) / 100).toFixed(2);

      giftText.textContent =
        `Add $${away} more for a free gift.`;

      giftText.classList.remove("is-complete");
      giftMarker.classList.remove("reached");
    }
  }    


  // ============================================================
  // Free Shipping
  // ============================================================

  if (itemsSubtotalPrice >= freeShippingPrice) {
    shippingText.textContent =
      "Hooray! Your order ships free.";

    shippingText.classList.add("is-complete");
    shippingMarker.classList.add("reached");
  } else {
    const away =
      ((freeShippingPrice - itemsSubtotalPrice) / 100).toFixed(2);

    shippingText.textContent =
      `Add $${away} more for free shipping.`;

    shippingText.classList.remove("is-complete");
    shippingMarker.classList.remove("reached");
  }

  return true;
}


// ============================================================
// Free Shipping State
// ============================================================

let freeShippingUpdateTimer = null;
let freeShippingObserverTimer = null;

let freeShippingRequestInProgress = false;
let freeShippingLastCartState = null;


// ============================================================
// Get Current Cart
// ============================================================

function refreshFreeShippingBar() {
  // Prevent multiple /cart.js requests at the same time
  if (freeShippingRequestInProgress) {
    console.log(
      "Free shipping cart request already running"
    );
    return;
  }

  freeShippingRequestInProgress = true;

  console.log("Fetching cart for free shipping bar");

  fetch("/cart.js")
    .then((response) => {
      if (!response.ok) {
        throw new Error(
          `Cart request failed: ${response.status}`
        );
      }

      return response.json();
    })
    .then((cart) => {
      // Only use the cart properties that affect the shipping bar
      const cartState = JSON.stringify({
        item_count: cart.item_count,
        items_subtotal_price: cart.items_subtotal_price,

        items: cart.items.map((item) => ({
          key: item.key,
          quantity: item.quantity,
          final_line_price: item.final_line_price,
          properties: item.properties
        }))
      });


      // Skip DOM update if cart hasn't changed
      if (cartState === freeShippingLastCartState) {
        console.log(
          "Free shipping cart unchanged - skipping update"
        );

        return;
      }

      freeShippingLastCartState = cartState;

      freeShippingSlider(cart);
    })
    .catch((error) => {
      console.error(
        "Free shipping cart fetch error:",
        error
      );
    })
    .finally(() => {
      freeShippingRequestInProgress = false;
    });
}


// ============================================================
// Check if Free Shipping Elements Exist
// ============================================================

function hasFreeShippingElements() {
  const progressBox =
    document.querySelector("#cart_progressbox");

  const progressBar =
    document.querySelector("#cart-progress");

  const progressText =
    document.querySelector("#free_shipping_price_text");

  const shippingMarker =
    document.querySelector("#shipping-marker");

  if (
    !progressBox ||
    !progressBar ||
    !progressText ||
    !shippingMarker
  ) {
    return false;
  }

  const showGift =
    progressBox.getAttribute("data-show-gift") === "true";

  if (showGift) {
    const giftText =
      document.querySelector("#free_gift_price_text");

    const giftMarker =
      document.querySelector("#gift-marker");

    if (!giftText || !giftMarker) {
      return false;
    }
  }

  return true;
}


// ============================================================
// Single Free Shipping Update Scheduler
// ============================================================

function scheduleFreeShippingUpdate(delay = 150) {
  clearTimeout(freeShippingUpdateTimer);

  freeShippingUpdateTimer = setTimeout(() => {
    if (!hasFreeShippingElements()) {
      console.log(
        "Free shipping elements not ready yet"
      );

      return;
    }

    console.log(
      "Updating free shipping bar"
    );

    refreshFreeShippingBar();
  }, delay);
}


// ============================================================
// Retry Until Cart Drawer Elements Exist
// ============================================================

function updateFreeShippingWithRetry() {
  let attempts = 0;

  const maxAttempts = 10;

  function attemptUpdate() {
    attempts++;

    if (hasFreeShippingElements()) {
      scheduleFreeShippingUpdate(0);
      return;
    }

    if (attempts < maxAttempts) {
      setTimeout(attemptUpdate, 150);
    }
  }

  attemptUpdate();
}


// ============================================================
// 1. Initial Page Load
// ============================================================

document.addEventListener(
  "DOMContentLoaded",
  () => {
    updateFreeShippingWithRetry();
    observeCartDrawer();
  }
);


// ============================================================
// 2. Cart Drawer Open
// ============================================================

document.addEventListener(
  "click",
  (event) => {
    const cartTrigger = event.target.closest(
      '[data-cart-toggle], ' +
      '.header-cart, ' +
      '.open-cart, ' +
      '[data-testid="cart-drawer-trigger"]'
    );

    if (!cartTrigger) {
      return;
    }

    console.log(
      "Cart drawer opened"
    );

    updateFreeShippingWithRetry();
  }
); 


// ============================================================
// 3. Detect Shopify / Monk Cart Requests
// ============================================================

(function () {
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response =
      await originalFetch.apply(this, args);

    const url =
      typeof args[0] === "string"
        ? args[0]
        : args[0]?.url || "";


    const cartEndpoints = [
      "/cart/add.js",
      "/cart/change.js",
      "/cart/update.js",
      "monkcommerce.app",
      "monk-commerce"
    ];


    const isCartRequest =
      cartEndpoints.some((endpoint) =>
        url.includes(endpoint)
      );


    if (isCartRequest) {
      console.log(
        "Cart request detected:",
        url
      );

      /*
       * Do NOT immediately update.
       *
       * Horizon may still be rendering the
       * cart drawer. The delay allows Horizon
       * to finish its render.
       */
      scheduleFreeShippingUpdate(400);
    }

    return response;
  };
})();


// ============================================================
// 4. Observe ONLY Cart Drawer
// ============================================================

function observeCartDrawer() {
  const cartDrawer =
    document.querySelector(
      "cart-drawer-component, cart-drawer"
    );

  if (!cartDrawer) {
    console.log(
      "Cart drawer not found"
    );

    return;
  }


  console.log(
    "Free shipping cart observer started"
  );


  const observer =
    new MutationObserver(() => {

      /*
       * Horizon can make many DOM mutations
       * during one cart update.
       *
       * Debounce all mutations into ONE update.
       */

      clearTimeout(
        freeShippingObserverTimer
      );


      freeShippingObserverTimer =
        setTimeout(() => {

          if (!hasFreeShippingElements()) {
            return;
          }

          console.log(
            "Cart drawer changed - scheduling shipping update"
          );

          scheduleFreeShippingUpdate(100);

        }, 150);
    });


  observer.observe(cartDrawer, {
    childList: true,
    subtree: true
  });
}
 

// ============================================================
// 5. Monogram Text → Uppercase
// ============================================================

document.addEventListener(
  "input",
  function (event) {
    const element = event.target;

    if (
      element.name ===
      "properties[Monogram Text]"
    ) {
      element.value =
        element.value.toUpperCase();
    }
  }
);


document.addEventListener('DOMContentLoaded', function () {

  function getCurrentCurrency() {
    // Shopify Markets
    if (
      window.Shopify &&
      Shopify.currency &&
      Shopify.currency.active
    ) {
      return Shopify.currency.active;
    }

    // Fallback from currency selector
    const currencyInput = document.querySelector(
      'input[name="currency"], select[name="currency"]'
    );

    if (currencyInput) {
      return currencyInput.value;
    }

    return null;
  }


  function fixBulkDiscountCurrency() {

    const currency = getCurrentCurrency();

    if (!currency) return;

    document.querySelectorAll('.hulkapps-table tbody tr').forEach(function (row) {

      const cells = row.querySelectorAll('td');

      // Price Per Unit = third column
      if (cells.length < 3) return;

      const priceCell = cells[2];

      if (!priceCell) return;

      let value = priceCell.textContent.trim();

      if (!value) return;

      /*
       * Remove only an existing currency code/symbol
       * from the END of the price.
       */
      value = value
        .replace(/\s+(INR|USD|EUR|GBP|CAD|AUD|SGD|AED|JPY|CNY|NZD)\s*$/i, '')
        .trim();

      /*
       * Don't change Shopify/HulkApps number.
       * Only make sure current currency is displayed.
       */
      if (currency === 'INR') {
        priceCell.textContent = value + ' INR';
      } else {
        priceCell.textContent = value + ' ' + currency;
      }
    });
  }  


  /*
   * Initial load
   */
  setTimeout(fixBulkDiscountCurrency, 1000);

  /*
   * Customize / variant change
   */
  document.addEventListener('change', function (event) {

    if (
      event.target.matches(
        'input[type="radio"][data-swatch-option]'
      )
    ) {

      /*
       * Let HulkApps calculate the new price first.
       */
      setTimeout(fixBulkDiscountCurrency, 300);
      setTimeout(fixBulkDiscountCurrency, 700);
      setTimeout(fixBulkDiscountCurrency, 1200);
      setTimeout(fixBulkDiscountCurrency, 1800);
    }

  });


  /*
   * Shopify/HulkApps DOM updates
   */
  const observer = new MutationObserver(function () {

    clearTimeout(window.bulkCurrencyTimer);

    window.bulkCurrencyTimer = setTimeout(function () {
      fixBulkDiscountCurrency();
    }, 150);

  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

}); 